import { useDispatch } from 'react-redux';
import '../../css/base.css';
import { setPage} from '../../store/AppSlice';

const ThingsToDo = () => {

  const dispatch = useDispatch();

  const navigateToPage = (pageName) => {
    dispatch(setPage(pageName));
  }

  return (
    <div>
      <h2 className="your-stay-section-heading">Activities</h2>
      <p className="your-stay-text">The cottage is a great place to unwind and just watch the wildlife and the changing sea and weather.  We have supplied a pair of 
                                    binoculars and a telescope on a tripod for you to use.  So hopefully you can identify anything you see.  There is a whiteboard 
                                    on the fridge where you can see what has been spotted by other guests and to document your sightings.  
      </p>
      <p className="your-stay-text">If you do want to get out 
                                    and about there are lots of great ideas for fabulous things to do in the 
                                    <span className="navigate-span"><a className="navigate-button" onClick={() => navigateToPage("ACTIVITIES")}>activites</a></span>
                                    section of the website. 
      </p>                                            
      <p className="your-stay-text">Meals out are covered in 
                                    <span className="navigate-span"><a className="navigate-button" onClick={() => navigateToPage("EATING_OUT")}>dining</a></span>.
      </p>                                            
    </div>
  );
}

export default ThingsToDo
